import { useState, useMemo } from 'react';
import styles from './Logo.module.scss';

const PLACEHOLDER_COLORS = [
  '#312783', // blueberry
  '#b378b3', // grape
  '#2b6a6b', // kale
];

const getColorFromName = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (name.codePointAt(i) ?? 0) + ((hash << 5) - hash);
  }
  return PLACEHOLDER_COLORS[Math.abs(hash) % PLACEHOLDER_COLORS.length];
};

const getInitials = (name: string): string => {
  const trimmed = name.trim();
  const words = trimmed.split(/\s+/);
  if (words.length >= 2) {
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
};

export const Logo = ({
  src,
  name,
  className,
}: {
  src?: string | null;
  name: string;
  className?: string;
}) => {
  const [hasError, setHasError] = useState(false);

  const placeholderStyle = useMemo(
    () => ({
      backgroundColor: getColorFromName(name),
    }),
    [name],
  );

  if (hasError || !src) {
    return (
      <div
        className={`${styles['logo']} ${styles['logo-placeholder']} ${className}`}
        style={placeholderStyle}
      >
        {getInitials(name)}
      </div>
    );
  }

  return (
    <div className={`${styles['logo']} ${className}`}>
      <img
        src={src}
        alt={`${name} logo`}
        className={styles.logo}
        onError={() => setHasError(true)}
      />
    </div>
  );
};
